// The shared shell for every side panel. Panels collapse out of the way so the circle gets the
// screen space when they are not needed, which is the whole point of them being pop-outs.

import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "../../lib/ui.js";

export function Panel({
  title,
  badge,
  open,
  onOpenChange,
  children,
  className,
}: {
  title: string;
  badge?: ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      className={cn(
        "pointer-events-auto w-88 overflow-hidden rounded-lg border border-ink-line bg-ink-soft/95 backdrop-blur",
        className,
      )}
    >
      <button
        type="button"
        onClick={() => onOpenChange(!open)}
        className="flex w-full items-center justify-between gap-2 px-4 py-2.5 text-left"
      >
        <span className="flex items-baseline gap-2 text-base font-medium text-parchment">
          {title}
          {badge}
        </span>
        <ChevronDown className={cn("size-5 shrink-0 text-parchment-dim transition", open && "rotate-180")} />
      </button>
      {open && (
        <div className="max-h-[50vh] overflow-y-auto border-t border-ink-line px-4 py-3 cc-scroll">
          {children}
        </div>
      )}
    </section>
  );
}
